import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import Fetching from "@/components/Fetching/Fetching";

import classes from "./edit_single.module.scss";

const resolveOptionValue = (val, opts) => {
	const found = opts?.find((o) => String(o.value) === String(val));
	return found ? found.value : val;
};

const EditSingle = ({ options, handleChange, currentValue, currentLabel, needPermission = false, onCreateOption = null, minChars = 3 }) => {
	const { user } = useSelector((state) => state.auth);
	const tools = user ? user.tools : [];
	const profiles = user ? user.profiles : [];

	const [localValue, setLocalValue] = useState(() => resolveOptionValue(currentValue, options));
	const [edit, setEdit] = useState(false);
	const [fetching, setFetching] = useState(false);

	useEffect(() => {
		if (currentValue) {
			setLocalValue(resolveOptionValue(currentValue, options));
		}
	}, [currentValue, options]);

	const hasPermission = !needPermission || (!!tools.find((t) => t.id === 19) && !!profiles.find((p) => p.id === 4));

	const handleLocalChange = async () => {
		setEdit(false);
		setFetching(true);
		await handleChange(localValue);
		setFetching(false);
	};

	const handleLocalCreate = async (inputValue) => {
		setEdit(false);
		setFetching(true);
		await onCreateOption(inputValue);
		setFetching(false);
	};

	const renderContent = () => {
		if (fetching) {
			return <Fetching topMargin={"0em"} />;
		}

		if (edit) {
			const currentValueInOptions = options?.some((o) => String(o.value) === String(localValue));
			const optionsWithCurrent = currentValueInOptions || !localValue ? options : [{ value: localValue, label: currentLabel }, ...(options || [])];

			return (
				<div style={{ width: "100%" }}>
					<CustomInputSelect
						options={optionsWithCurrent}
						value={localValue}
						onChange={setLocalValue}
						placeholder="Seleccione"
						isClearable={false}
						creatable={!!onCreateOption}
						onCreateOption={handleLocalCreate}
						async={true}
						defaultOptions={true}
						minChars={minChars}
					/>
					<div className={classes.editable_button}>
						<button className={classes.button_cancel} onClick={() => setEdit(false)}>
							Cancelar
						</button>
						<button className={classes.button_confirm} onClick={handleLocalChange}>
							Guardar
						</button>
					</div>
				</div>
			);
		}

		return (
			<span onClick={() => hasPermission && setEdit(true)}>
				{currentLabel ? currentLabel : hasPermission ? <div className={classes.add_button}>Agregar</div> : ""}
			</span>
		);
	};

	return <>{renderContent()}</>;
};

export default EditSingle;
